import NTFSInputField from "./NTFSInputField";
import { SET_NTFS_HOST } from "../../../../redux/constants/constants";

function HostField(props) {
  const {
    ntfsHost,
    type,
  } = props;

  const isNTFSServer = type?.NTFS_SERVER?.selected;

  return (
    <>
    <NTFSInputField
      {...props}
      label={isNTFSServer ? "Host" : "Local Endpoints Group"}
      value={ntfsHost}
      placeholder={isNTFSServer ? "NTFS Hosts" : "NTFS Local Endpoints"}
      actionType={SET_NTFS_HOST}
      errorKey="ntfsHost"
      isNTFSServer={isNTFSServer}
    />
    </>
  );
}

export default HostField;
